export const SearchZoomIn = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5 20.9595C6.12 20.9595 1.75 16.5895 1.75 11.2095C1.75 5.82947 6.12 1.45947 11.5 1.45947C16.88 1.45947 21.25 5.82947 21.25 11.2095C21.25 16.5895 16.88 20.9595 11.5 20.9595ZM11.5 2.95947C6.95 2.95947 3.25 6.65947 3.25 11.2095C3.25 15.7595 6.95 19.4595 11.5 19.4595C16.05 19.4595 19.75 15.7595 19.75 11.2095C19.75 6.65947 16.05 2.95947 11.5 2.95947Z"
      fill="white"
    />
    <path
      d="M14 11.9595H9C8.59 11.9595 8.25 11.6195 8.25 11.2095C8.25 10.7995 8.59 10.4595 9 10.4595H14C14.41 10.4595 14.75 10.7995 14.75 11.2095C14.75 11.6195 14.41 11.9595 14 11.9595Z"
      fill="white"
    />
    <path
      d="M11.5 14.4595C11.09 14.4595 10.75 14.1195 10.75 13.7095V8.70947C10.75 8.29947 11.09 7.95947 11.5 7.95947C11.91 7.95947 12.25 8.29947 12.25 8.70947V13.7095C12.25 14.1195 11.91 14.4595 11.5 14.4595Z"
      fill="white"
    />
    <path
      d="M20.6601 22.9995C20.5801 22.9995 20.5001 22.9895 20.4301 22.9795C19.9601 22.9195 19.1101 22.5995 18.6301 21.1695C18.3801 20.4195 18.4701 19.6695 18.8801 19.0995C19.2901 18.5295 19.9801 18.2095 20.7701 18.2095C21.7901 18.2095 22.5901 18.5995 22.9501 19.2895C23.3101 19.9795 23.2101 20.8595 22.6401 21.7095C21.9301 22.7795 21.1601 22.9995 20.6601 22.9995ZM20.0601 20.6995C20.2301 21.2195 20.4701 21.4795 20.6301 21.4995C20.7901 21.5195 21.0901 21.3295 21.4001 20.8795C21.6901 20.4495 21.7101 20.1395 21.6401 19.9995C21.5701 19.8595 21.2901 19.7095 20.7701 19.7095C20.4601 19.7095 20.2301 19.8095 20.1001 19.9795C19.9801 20.1495 19.9601 20.4095 20.0601 20.6995Z"
      fill="white"
    />
  </svg>
);
